import { getTourStrings, type TourStepStrings } from '../utils/tour-strings';
import type { TourItemKey } from './use-tour-store';
import { useTourStore } from './use-tour-store';

export const useTourStrings = (tourItemKey: TourItemKey): TourStepStrings => {
  const appliedQuickAction = useTourStore((state) => state.appliedQuickAction);
  return getTourStrings(tourItemKey, appliedQuickAction);
};
